<template>
  <header id="header" class="ct-header" data-id="type-1" itemscope="" itemtype="https://schema.org/WPHeader">
    <!-- Desktop Header -->
    <div data-device="desktop" data-transparent="">
      <div class="ct-sticky-container">
        <div data-sticky="shrink">
          <div data-row="middle" data-column-set="3" data-transparent-row="yes">
            <div class="ct-container">
              <div data-column="start" data-placements="1">
                <div data-items="primary">
                  <div class="site-branding" data-id="logo" itemscope="itemscope"
                    itemtype="https://schema.org/Organization">
                    <router-link to="/" class="site-logo-container" rel="home" itemprop="url">
                      <img fetchpriority="high" width="5086" height="904"
                        src="/wp-content/uploads/2024/02/Logo-Socrates-Long.png"
                        class="sticky-logo" alt="Socrates Legacy" itemprop="logo" decoding="async"
                        srcset="/wp-content/uploads/2024/02/Logo-Socrates-Long.png 5086w, /wp-content/uploads/2024/02/Logo-Socrates-Long-300x53.png 300w, /wp-content/uploads/2024/02/Logo-Socrates-Long-1024x182.png 1024w, /wp-content/uploads/2024/02/Logo-Socrates-Long-768x137.png 768w, /wp-content/uploads/2024/02/Logo-Socrates-Long-1536x273.png 1536w, /wp-content/uploads/2024/02/Logo-Socrates-Long-2048x364.png 2048w"
                        sizes="(max-width: 5086px) 100vw, 5086px" />
                      <img width="5086" height="904"
                        src="/wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng.png"
                        class="default-logo" alt="Socrates Legacy" itemprop="logo" decoding="async"
                        srcset="/wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng.png 5086w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-300x53.png 300w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-1024x182.png 1024w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-768x137.png 768w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-1536x273.png 1536w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-2048x364.png 2048w"
                        sizes="(max-width: 5086px) 100vw, 5086px" />
                    </router-link>
                  </div>
                </div>
              </div>
              <div data-column="middle">
                <div data-items="">
                  <nav id="header-menu-1" class="header-menu-1" data-id="menu" data-interaction="hover"
                    data-menu="type-1" data-dropdown="type-1:simple" data-responsive="no" itemscope=""
                    itemtype="https://schema.org/SiteNavigationElement" aria-label="Header Menu">
                    <ul id="menu-menu-header" class="menu" role="menubar">
                      <li id="menu-item-903"
                        :class="['menu-item', 'menu-item-type-post_type', 'menu-item-object-page', 'menu-item-home', 'menu-item-903', 
                                 isActive('Login') ? 'current-menu-item page_item page-item-9 current_page_item' : '']"
                        role="none">
                        <router-link to="/" :aria-current="isActive('Login') ? 'page' : null" class="ct-menu-link"
                          role="menuitem">Home</router-link>
                      </li>
                      <li id="menu-item-904"
                        :class="['menu-item', 'menu-item-type-post_type', 'menu-item-object-page', 'menu-item-904',
                                 isActive('Account') ? 'current-menu-item page_item current_page_item' : '']"
                        role="none">
                        <router-link to="/account" :aria-current="isActive('Account') ? 'page' : null" class="ct-menu-link"
                          role="menuitem">Account</router-link>
                      </li>
                      <li id="menu-item-905"
                        :class="['menu-item', 'menu-item-type-post_type', 'menu-item-object-page', 'menu-item-905',
                                 isActive('About') ? 'current-menu-item page_item current_page_item' : '']"
                        role="none">
                        <router-link to="/about" :aria-current="isActive('About') ? 'page' : null" class="ct-menu-link" role="menuitem">About</router-link>
                      </li>
                      <li id="menu-item-906"
                        :class="['menu-item', 'menu-item-type-post_type', 'menu-item-object-page', 'menu-item-906',
                                 isActive('ContactUs') ? 'current-menu-item page_item current_page_item' : '']"
                        role="none">
                        <router-link to="/contact-us" :aria-current="isActive('ContactUs') ? 'page' : null" class="ct-menu-link"
                          role="menuitem">Contact Us</router-link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div data-column="end" data-placements="1">
                <div data-items="primary">
                  <nav id="header-menu-2" class="header-menu-2" data-id="menu-secondary" data-interaction="hover"
                    data-menu="type-1" data-dropdown="type-1:simple" data-responsive="no" itemscope=""
                    itemtype="https://schema.org/SiteNavigationElement" aria-label="Header Menu">
                    <ul id="menu-menu-2" class="menu" role="menubar">
                      <li id="menu-item-1089"
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-1089" role="none">
                        <router-link to="/login" class="ct-menu-link" role="menuitem">Login</router-link>
                      </li>
                    </ul>
                  </nav>
                  <div class="ct-header-cta" data-id="button">
                    <router-link to="/signup" class="ct-button" data-size="small"
                      aria-label="Sign Up">
                      Sign Up
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Header -->
    <div data-device="mobile" data-transparent="">
      <div class="ct-sticky-container">
        <div data-sticky="shrink">
          <div data-row="middle" data-column-set="2" data-transparent-row="yes">
            <div class="ct-container">
              <div data-column="start" data-placements="1">
                <div data-items="primary">
                  <div class="site-branding" data-id="logo">
                    <router-link to="/" class="site-logo-container" rel="home" itemprop="url">
                      <img fetchpriority="high" width="5086" height="904"
                        src="/wp-content/uploads/2024/02/Logo-Socrates-Long.png"
                        class="sticky-logo" alt="Socrates Legacy" itemprop="logo" decoding="async"
                        srcset="/wp-content/uploads/2024/02/Logo-Socrates-Long.png 5086w, /wp-content/uploads/2024/02/Logo-Socrates-Long-300x53.png 300w, /wp-content/uploads/2024/02/Logo-Socrates-Long-1024x182.png 1024w, /wp-content/uploads/2024/02/Logo-Socrates-Long-768x137.png 768w, /wp-content/uploads/2024/02/Logo-Socrates-Long-1536x273.png 1536w, /wp-content/uploads/2024/02/Logo-Socrates-Long-2048x364.png 2048w"
                        sizes="(max-width: 5086px) 100vw, 5086px" />
                      <img width="5086" height="904"
                        src="/wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng.png"
                        class="default-logo" alt="Socrates Legacy" itemprop="logo" decoding="async"
                        srcset="/wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng.png 5086w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-300x53.png 300w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-1024x182.png 1024w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-768x137.png 768w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-1536x273.png 1536w, /wp-content/uploads/2024/02/Logo-Socrates-Long.-whitepng-2048x364.png 2048w"
                        sizes="(max-width: 5086px) 100vw, 5086px" />
                    </router-link>
                  </div>
                </div>
              </div>
              <div data-column="end" data-placements="1">
                <div data-items="primary">
                  <div class="ct-header-cta" data-id="button">
                    <router-link to="/signup" class="ct-button" data-size="small"
                      aria-label="Sign Up">
                      Sign Up
                    </router-link>
                  </div>
                  <button data-toggle-panel="#offcanvas" class="ct-header-trigger ct-toggle " data-design="simple"
                    data-label="right" aria-label="Menu" data-id="trigger">
                    <span class="ct-label ct-hidden-sm ct-hidden-md ct-hidden-lg">Menu</span>
                    <svg width="18" height="14" class="ct-icon" aria-hidden="true">
                      <use href="/assets/svg/sprite.svg#ct_icon_4"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'LandingHeader',
  computed: {
    isActive() {
      return (routeName) => {
        return this.$route.name === routeName;
      }
    }
  }
}
</script>